<div style="max-width: 488px;">
  <div [formGroup]="fileLoadForm" class="ui form">
    <div class="fields">
      <div class="sixteen wide field">
        <dx-combobox
          controlId="ctrlDocumentType"
          [formControlInstance]="controls['ctrlDocumentType']"
          [options]="ctrlDocumentTypeOptions">
        </dx-combobox>
      </div>
    </div>
    <div class="fields">
      <div class="sixteen wide field">
        <dx-textarea controlId="ctrlNote"
                     [formControlInstance]="controls['ctrlNote']"
                     [options]="{
                        label: 'Примечание',
                        rows: 3
                     }">
        </dx-textarea>
      </div>
    </div>
    <div class="fields">
      <div class="sixteen wide field">
        <dx-file controlId="ctrlFile"
                 [formControlInstance]="controls['ctrlFile']"
                 [options]="{label: 'Документ'}"
                 (change)="handleFileInput($event?.target?.files)">
        </dx-file>
      </div>
    </div>
  </div>
</div>
